import { render, staticRenderFns } from "./FamousCommentListWeb.vue?vue&type=template&id=078e8597&"
import script from "./FamousCommentListWeb.vue?vue&type=script&lang=js&"
export * from "./FamousCommentListWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports